/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestError from '../model/BadRequestError';
import NotFoundError from '../model/NotFoundError';
import ServiceUnavailableError from '../model/ServiceUnavailableError';
import VoteCreate from '../model/VoteCreate';
import VoteList from '../model/VoteList';
import VoteRead from '../model/VoteRead';
import VoteUpdate from '../model/VoteUpdate';

/**
* Vote service.
* @module api/VoteApi
* @version 1.7.2
*/
export default class VoteApi {

    /**
    * Constructs a new VoteApi. 
    * @alias module:api/VoteApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createArticleCommentVote operation.
     * @callback module:api/VoteApi~createArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createArticleCommentVote(acceptLanguage, articleId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling createArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createArticleCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createImageCommentVote operation.
     * @callback module:api/VoteApi~createImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createImageCommentVote(acceptLanguage, imageId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling createImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createImageCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createProductCommentVote operation.
     * @callback module:api/VoteApi~createProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createProductCommentVote(acceptLanguage, productId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling createProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createProductCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createRecipeCommentVote operation.
     * @callback module:api/VoteApi~createRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createRecipeCommentVote(acceptLanguage, recipeId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createRecipeCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createTaxonCommentVote operation.
     * @callback module:api/VoteApi~createTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createTaxonCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the createVideoCommentVote operation.
     * @callback module:api/VoteApi~createVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates the Vote for the Comment of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {module:model/VoteCreate} vote The new Vote resource
     * @param {module:api/VoteApi~createVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    createVideoCommentVote(acceptLanguage, videoId, commentId, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling createVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling createVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling createVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteArticleCommentVote operation.
     * @callback module:api/VoteApi~deleteArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Article.
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteArticleCommentVote(articleId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling deleteArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteImageCommentVote operation.
     * @callback module:api/VoteApi~deleteImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Image.
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteImageCommentVote(imageId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling deleteImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteProductCommentVote operation.
     * @callback module:api/VoteApi~deleteProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Product.
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteProductCommentVote(productId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling deleteProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteRecipeCommentVote operation.
     * @callback module:api/VoteApi~deleteRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Recipe.
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteRecipeCommentVote(recipeId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling deleteRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteTaxonCommentVote operation.
     * @callback module:api/VoteApi~deleteTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Taxon.
     * @param {String} taxonId 
     * @param {String} taxonomyName 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTaxonCommentVote(taxonId, taxonomyName, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteTaxonCommentVote");
      }

      let pathParams = {
        'taxon_id': taxonId,
        'taxonomy_name': taxonomyName,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteVideoCommentVote operation.
     * @callback module:api/VoteApi~deleteVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the Vote of the Comment resource of Video.
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~deleteVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteVideoCommentVote(videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling deleteVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentVote operation.
     * @callback module:api/VoteApi~getArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getArticleCommentVote(acceptLanguage, articleId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getArticleCommentVoteList operation.
     * @callback module:api/VoteApi~getArticleCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getArticleCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getArticleCommentVoteList(acceptLanguage, articleId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getArticleCommentVoteList");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling getArticleCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getArticleCommentVoteList");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentVote operation.
     * @callback module:api/VoteApi~getImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getImageCommentVote(acceptLanguage, imageId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getImageCommentVoteList operation.
     * @callback module:api/VoteApi~getImageCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getImageCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getImageCommentVoteList(acceptLanguage, imageId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getImageCommentVoteList");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling getImageCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getImageCommentVoteList");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentVote operation.
     * @callback module:api/VoteApi~getProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getProductCommentVote(acceptLanguage, productId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getProductCommentVoteList operation.
     * @callback module:api/VoteApi~getProductCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getProductCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getProductCommentVoteList(acceptLanguage, productId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getProductCommentVoteList");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling getProductCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getProductCommentVoteList");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentVote operation.
     * @callback module:api/VoteApi~getRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getRecipeCommentVote(acceptLanguage, recipeId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRecipeCommentVoteList operation.
     * @callback module:api/VoteApi~getRecipeCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getRecipeCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getRecipeCommentVoteList(acceptLanguage, recipeId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getRecipeCommentVoteList");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling getRecipeCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getRecipeCommentVoteList");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentVote operation.
     * @callback module:api/VoteApi~getTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getTaxonCommentVoteList operation.
     * @callback module:api/VoteApi~getTaxonCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getTaxonCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getTaxonCommentVoteList(acceptLanguage, taxonomyName, taxonId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling getTaxonCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getTaxonCommentVoteList");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVote operation.
     * @callback module:api/VoteApi~getVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrives the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:api/VoteApi~getVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    getVideoCommentVote(acceptLanguage, videoId, commentId, id, callback) {
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getVideoCommentVoteList operation.
     * @callback module:api/VoteApi~getVideoCommentVoteListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VoteList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of Votes for the Comment resources for Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {Object} opts Optional parameters
     * @param {String} opts.search 
     * @param {Number} opts.page The list page number
     * @param {module:api/VoteApi~getVideoCommentVoteListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/VoteList>}
     */
    getVideoCommentVoteList(acceptLanguage, videoId, commentId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling getVideoCommentVoteList");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling getVideoCommentVoteList");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId
      };
      let queryParams = {
        'search': opts['search'],
        'page': opts['page']
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [VoteList];
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateArticleCommentVote operation.
     * @callback module:api/VoteApi~updateArticleCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Article.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} articleId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateArticleCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateArticleCommentVote(acceptLanguage, articleId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'articleId' is set
      if (articleId === undefined || articleId === null) {
        throw new Error("Missing the required parameter 'articleId' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateArticleCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateArticleCommentVote");
      }

      let pathParams = {
        'article_id': articleId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/articles/{article_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateImageCommentVote operation.
     * @callback module:api/VoteApi~updateImageCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Image.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} imageId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateImageCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateImageCommentVote(acceptLanguage, imageId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateImageCommentVote");
      }
      // verify the required parameter 'imageId' is set
      if (imageId === undefined || imageId === null) {
        throw new Error("Missing the required parameter 'imageId' when calling updateImageCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateImageCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateImageCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateImageCommentVote");
      }

      let pathParams = {
        'image_id': imageId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/images/{image_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateProductCommentVote operation.
     * @callback module:api/VoteApi~updateProductCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Product.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} productId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateProductCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateProductCommentVote(acceptLanguage, productId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateProductCommentVote");
      }
      // verify the required parameter 'productId' is set
      if (productId === undefined || productId === null) {
        throw new Error("Missing the required parameter 'productId' when calling updateProductCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateProductCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateProductCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateProductCommentVote");
      }

      let pathParams = {
        'product_id': productId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/products/{product_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateRecipeCommentVote operation.
     * @callback module:api/VoteApi~updateRecipeCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Recipe.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} recipeId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateRecipeCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateRecipeCommentVote(acceptLanguage, recipeId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'recipeId' is set
      if (recipeId === undefined || recipeId === null) {
        throw new Error("Missing the required parameter 'recipeId' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateRecipeCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateRecipeCommentVote");
      }

      let pathParams = {
        'recipe_id': recipeId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/recipes/{recipe_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateTaxonCommentVote operation.
     * @callback module:api/VoteApi~updateTaxonCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Taxon.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} taxonomyName 
     * @param {String} taxonId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateTaxonCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateTaxonCommentVote(acceptLanguage, taxonomyName, taxonId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'taxonomyName' is set
      if (taxonomyName === undefined || taxonomyName === null) {
        throw new Error("Missing the required parameter 'taxonomyName' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'taxonId' is set
      if (taxonId === undefined || taxonId === null) {
        throw new Error("Missing the required parameter 'taxonId' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateTaxonCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateTaxonCommentVote");
      }

      let pathParams = {
        'taxonomy_name': taxonomyName,
        'taxon_id': taxonId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/taxonomies/{taxonomy_name}/taxons/{taxon_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateVideoCommentVote operation.
     * @callback module:api/VoteApi~updateVideoCommentVoteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoteRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Replaces the Vote of the Comment resource of Video.
     * @param {module:model/String} acceptLanguage Locale code
     * @param {String} videoId 
     * @param {String} commentId 
     * @param {String} id 
     * @param {module:model/VoteUpdate} vote The updated Vote resource
     * @param {module:api/VoteApi~updateVideoCommentVoteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoteRead}
     */
    updateVideoCommentVote(acceptLanguage, videoId, commentId, id, vote, callback) {
      let postBody = vote;
      // verify the required parameter 'acceptLanguage' is set
      if (acceptLanguage === undefined || acceptLanguage === null) {
        throw new Error("Missing the required parameter 'acceptLanguage' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'videoId' is set
      if (videoId === undefined || videoId === null) {
        throw new Error("Missing the required parameter 'videoId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'commentId' is set
      if (commentId === undefined || commentId === null) {
        throw new Error("Missing the required parameter 'commentId' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateVideoCommentVote");
      }
      // verify the required parameter 'vote' is set
      if (vote === undefined || vote === null) {
        throw new Error("Missing the required parameter 'vote' when calling updateVideoCommentVote");
      }

      let pathParams = {
        'video_id': videoId,
        'comment_id': commentId,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
        'Accept-Language': acceptLanguage
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = VoteRead;
      return this.apiClient.callApi(
        '/videos/{video_id}/comments/{comment_id}/votes/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
